/** When a booking/event is created from a schedule quick action, the schedule
 * query can refetch by listening for this event (avoids prop drilling from
 * `BookingsPage` into `BookingsScheduleContent`).
 *
 * Mirrors the pattern in `schedule-block-times-refetch.js`. */
export const SCHEDULE_BOOKINGS_REFETCH_EVENT = 'cp:refetch-schedule-bookings'

export function emitScheduleBookingsRefetch() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(SCHEDULE_BOOKINGS_REFETCH_EVENT))
}
